import { FaqEntryStatus } from '@zvoove-market/api';

export const faqEntryStatusDict = {
  [FaqEntryStatus.archived]: () => $localize`:@@general.archived:Archiviert`,
  [FaqEntryStatus.draft]: () => $localize`:@@general.draft:Entwurf`,
  [FaqEntryStatus.published]: () => $localize`:@@general.published:Veröffentlicht`,
};

export const faqEntryStatusItems = () =>
  Object.entries(faqEntryStatusDict).map((x) => ({
    id: parseInt(x[0], 10),
    name: x[1](),
  }));
